import {AfterContentChecked, Component, ElementRef, OnInit, ViewEncapsulation} from '@angular/core';
import { NutritionFacadeService } from '@emm/management/services/nutrition-facade.service';
import {NutritionLocation} from '@emm/core/models/nutrition.model';
import {LocationSetTypesFacadeService} from '@emm/management/services/location-set-types-facade.service';
import {ManagementApiService} from '@emm/management/services/management-api.service';
import {NotificationService} from '@emm/shared/services/notification.service';
import {LocationSetService} from '@emm/core/services/location-set.service';
import {LocationSet} from '@emm/core/models/location-set.model';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'emm-search-by-location',
    styleUrls: ['./search-by-location.component.scss'],
    templateUrl: './search-by-location.component.html',
    standalone: false
})
export class SearchByLocationComponent implements OnInit, AfterContentChecked {

    top = 0;
    foundOptions: { name: string, tag: string }[];
    left = 0;
    locations: NutritionLocation[] = [];
    keyword = '';
    searchActive = false;
    searchPlaceholder: string;
    width = 0;

    searchByTag$ = this.locationSetService
        .getAllLocationSetsByTag('LOCATION')
        .subscribe((data: LocationSet[]) => {
            this.locations = data.map(({ name, tag }) => ({ name, tag }));
            this.searchPlaceholder = 'Search for a location';
        });

    constructor(private locationSetsFacade: LocationSetTypesFacadeService,
        private locationSetService: LocationSetService,
        private nutritionFacadeService: NutritionFacadeService,
        private managementApiService: ManagementApiService,
        private notificationService: NotificationService,
                private element: ElementRef) {}



    ngOnInit(): void {
        this.searchPlaceholder = 'Loading...';
        this.managementApiService.getAllLocationSetsByTag('LOCATION')
            .subscribe({
                next: (foundLocations)=> {
                    this.locations = foundLocations.map(({name, tag}) => ({name, tag}));
                    this.searchPlaceholder = 'Search for a location';
                },
                error: (error) => {
                    this.notificationService.error(error)
                },
        });

    }

    ngAfterContentChecked(): void {
        this.width = this.element.nativeElement.children[0].offsetWidth || 0;
        const rect = this.element.nativeElement.children[0].getBoundingClientRect();
        this.left = rect.x;
        this.top = rect.bottom;
    }

    handleTyping(): void {
        const term = this.keywordToSearchTerm();
        if (term.length >= 3) {
            this.foundOptions = this.locations.filter(({ name, tag }) => {
                name = name.replace(name, name.toLowerCase());
                tag = tag.replace(tag, tag.toLowerCase());
                return name.match(term) || tag.match(term);
            });
        }
    }


    keywordToSearchTerm(): string {
        while (this.keyword.match(/^\s/)) {
            this.keyword = this.keyword.replace(/^\s/, '');
        }
        while (this.keyword.match(/\s\s/)) {
            this.keyword = this.keyword.replace(/\s\s/, ' ');
        }
        let term = this.keyword;
        while (term.match(/\s$/)) {
            term = term.replace(/\s$/, '');
        }
        return term.replace(/[^\w\s]/g, '').toLowerCase();
    }

    handleLocationClick(location: NutritionLocation): void {
        this.keyword = '';
        this.searchPlaceholder = 'Search for a location';
        if (location) {
            this.searchPlaceholder = `${location.tag}: ${location.name}`;
            this.nutritionFacadeService.selectedLocation(location);
        }
    }

    handleClearClick(): void {
        this.keyword = '';
        this.searchPlaceholder = 'Search for a location';
        this.nutritionFacadeService.clearedLocation();
    }



}
